import script from "./studentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./studentDetails.vue?vue&type=script&setup=true&lang=js"

import "./studentDetails.vue?vue&type=style&index=0&id=6a2d8664&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2d8664"]])

export default __exports__